import {AntragsdatenSchluessel} from "@wba/models/enums/antragsdaten-schluessel.enum";
import {ProgressNavItemsEnum} from "@wba/models/enums/progress-nav-items.enum";
import {ProgressNavigationListV2} from "@wba/models/progress-navigation-list";

export interface RouteInfo {
  label: string;
  link: string;
}

const routeMap: Partial<Record<AntragsdatenSchluessel, RouteInfo>> = {
  [AntragsdatenSchluessel.DRAFT_BG]: { label: ProgressNavigationListV2[0].label, link: ProgressNavigationListV2[0].url },
  [AntragsdatenSchluessel.DRAFT_HG]: { label: ProgressNavigationListV2[1].label, link: ProgressNavigationListV2[1].url },
  [AntragsdatenSchluessel.DRAFT_UMZUG]: { label: ProgressNavigationListV2[2].label, link: ProgressNavigationListV2[2].url },
  [AntragsdatenSchluessel.DRAFT_KDU]: { label: ProgressNavigationListV2[3].label, link: ProgressNavigationListV2[3].url },
  [AntragsdatenSchluessel.DRAFT_KONTO]: { label: ProgressNavigationListV2[4].label, link: ProgressNavigationListV2[4].url },
  [AntragsdatenSchluessel.DRAFT_EINKOMMEN]: { label: ProgressNavigationListV2[5].label, link: ProgressNavigationListV2[5].url },
  [AntragsdatenSchluessel.DRAFT_ABSETZUNG]: { label: ProgressNavigationListV2[6].label, link: ProgressNavigationListV2[6].url },
  [AntragsdatenSchluessel.DRAFT_WEITERE_AENDERUNGEN]: { label: ProgressNavigationListV2[7].label, link: ProgressNavigationListV2[7].url },
  [AntragsdatenSchluessel.DRAFT_EK_ARBEITSEINKOMMEN]: { label: 'Arbeitseinkommen', link: '/wba/einkommen/arbeitseinkommen' },
  [AntragsdatenSchluessel.DRAFT_EK_KINDERGELD]: { label: 'Kindergeld', link: '/wba/einkommen/kindergeld' },
  [AntragsdatenSchluessel.DRAFT_EK_UNTERHALTSZAHLUNGEN]: { label: 'Unterhaltszahlungen', link: '/wba/einkommen/unterhaltszahlungen' },
  [AntragsdatenSchluessel.DRAFT_EK_ARBEITSLOSENGELD]: { label: 'Arbeitslosengeld', link: '/wba/einkommen/arbeitslosengeld' },
  [AntragsdatenSchluessel.DRAFT_EK_RENTE]: { label: 'Rente', link: '/wba/einkommen/rente' },
  [AntragsdatenSchluessel.DRAFT_EK_WEITERE_SOZIALLEISTUNGEN]: { label: 'Weitere Sozialleistungen', link: '/wba/einkommen/weitere_sozialleistungen' },
  [AntragsdatenSchluessel.DRAFT_EK_SONSTIGE_ENTGELTERSATZLEISTUNG]: { label: 'Sonstige Entgeltersatzleistung', link: '/wba/einkommen/sonstige_entgeltersatzleistung' },
  [AntragsdatenSchluessel.DRAFT_EK_SONSTIGE_LAUFENDE_EINNAHMEN]: { label: 'Sonstige laufende Einnahmen', link: '/wba/einkommen/sonstige_laufende_einnahmen' },
  [AntragsdatenSchluessel.DRAFT_EK_GEMEINNUETZIGE_TAETIGKEIT]: { label: 'Gemeinnützige Tätigkeit', link: '/wba/einkommen/gemeinnuetzige_taetigkeit' },
  [AntragsdatenSchluessel.DRAFT_EK_EINNAHMEN_AUS_VERMIETUNG]: { label: 'Einnahmen aus Vermietung', link: '/wba/einkommen/einnahmen_aus_vermietung' },
  [AntragsdatenSchluessel.DRAFT_EK_EINMALIGE_EINNAHMEN]: { label: 'Einmalige Einnahmen', link: '/wba/einkommen/einmalige_einnahmen' },
  [AntragsdatenSchluessel.DRAFT_EK_SACHBEZUEGE]: { label: 'Sachbezüge', link: '/wba/einkommen/sachbezuege' },
  [AntragsdatenSchluessel.DRAFT_EK_SELBSTAENDIGE_TAETIGKEIT]: { label: 'Selbständige Tätigkeit', link: '/wba/einkommen/selbstaendige_taetigkeit' },
  [AntragsdatenSchluessel.DRAFT_EK_BAFOEG]: { label: 'Bafög', link: '/wba/einkommen/bafoeg' },
};
export function getRouteInfo(key: string): RouteInfo | undefined {
  return routeMap[key];
}

export function mapNavItem(array: string[]): Set<ProgressNavItemsEnum> {

  const resultSet = new Set<ProgressNavItemsEnum>();
  array.forEach(str => {
    switch (true) {
      case str.startsWith('DRAFT_EK_') || str===AntragsdatenSchluessel.DRAFT_EINKOMMEN:
        resultSet.add(ProgressNavItemsEnum.EINKOMMEN);
        break;
      case str===AntragsdatenSchluessel.DRAFT_BG:
        resultSet.add(ProgressNavItemsEnum.BG);
        break;
      case str===AntragsdatenSchluessel.DRAFT_HG:
        resultSet.add(ProgressNavItemsEnum.HG);
        break;
      case str===AntragsdatenSchluessel.DRAFT_UMZUG:
        resultSet.add(ProgressNavItemsEnum.UMZUG);
        break;
      case str===AntragsdatenSchluessel.DRAFT_KDU:
        resultSet.add(ProgressNavItemsEnum.KDU);
        break;
      case str===AntragsdatenSchluessel.DRAFT_KONTO:
        resultSet.add(ProgressNavItemsEnum.KONTOAUSZUEGE);
        break;
      case str===AntragsdatenSchluessel.DRAFT_ABSETZUNG:
        resultSet.add(ProgressNavItemsEnum.ABSETZUNGEN);
        break;
      case str===AntragsdatenSchluessel.DRAFT_WEITERE_AENDERUNGEN:
        resultSet.add(ProgressNavItemsEnum.WEITERE_AENDERUNGEN);
        break;
    }
  });
  return resultSet;
}
